/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "booking",
            "endpoint": "https://r2fw75k75j.execute-api.eu-west-1.amazonaws.com/beta",
            "region": "eu-west-1"
        },
        {
            "name": "cerfa",
            "endpoint": "https://30sfpekt94.execute-api.eu-west-1.amazonaws.com/beta",
            "region": "eu-west-1"
        },
        {
            "name": "documents",
            "endpoint": "https://c32ts0dme1.execute-api.eu-west-1.amazonaws.com/beta",
            "region": "eu-west-1"
        },
        {
            "name": "email",
            "endpoint": "https://a7x2ljw7w0.execute-api.eu-west-1.amazonaws.com/beta",
            "region": "eu-west-1"
        },
        {
            "name": "fhir",
            "endpoint": "https://m6p975af8d.execute-api.eu-west-1.amazonaws.com/beta",
            "region": "eu-west-1"
        },
        {
            "name": "payment",
            "endpoint": "https://c6s6nub13g.execute-api.eu-west-1.amazonaws.com/beta",
            "region": "eu-west-1"
        },
        {
            "name": "twilio",
            "endpoint": "https://p3jov4w4we.execute-api.eu-west-1.amazonaws.com/beta",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:c6deb938-2617-4ad2-996b-04048126b4da",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_XIqb63CRd",
    "aws_user_pools_web_client_id": "2a840ak9s5en3cb978gq7ttbho",
    "oauth": {
        "domain": "medeo-dev.auth.eu-west-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
